import createExchangeQuotesAtom from './exchange-quotes';
import createExchangeStatusAtom from './exchange-status';
import createExchangeRemoteConfigAtom from './exchange-remote-config';
import createExchangeAvailabilityAtom from './exchange-availability';
export const exchangeStatusAtomDefinition = {
    id: 'exchangeStatusAtom',
    type: 'atom',
    factory: createExchangeStatusAtom,
    dependencies: [],
    public: true,
};
export const exchangeQuotesAtomDefinition = {
    id: 'exchangeQuotesAtom',
    type: 'atom',
    factory: createExchangeQuotesAtom,
    dependencies: [],
    public: true,
};
export const exchangeRemoteConfigAtomDefinition = {
    id: 'exchangeRemoteConfigAtom',
    type: 'atom',
    factory: createExchangeRemoteConfigAtom,
    dependencies: ['remoteConfig'],
    public: true,
};
export const exchangeAvailabilityAtomDefinition = {
    id: 'exchangeAvailabilityAtom',
    type: 'atom',
    factory: createExchangeAvailabilityAtom,
    dependencies: [],
    public: false,
};
